<div class="frf-page min-vh-100 bg-light d-flex flex-column">
  <!-- —— Screen 1: Search + recent students —— -->
  <ng-container *ngIf="!selectedStudent && !submitted">
    <section class="pb-0">
      <div class="container frf-page-header pt-4">
        <h1 class="h4 frf-title text-dark mb-3 d-inline-flex align-items-center">
          Well Being Referral Form
        </h1>
      </div>

      <div class="container pb-4">
        <div class="row">
          <div class="col-12 col-md-12 col-lg-12">
            <div class="frf-search-card mb-3">
              <div class="frf-search-card-body">
                <label class="frf-search-label d-inline-flex align-items-center gap-2" for="frf-admission-search">
                  Search student (Admission No / Mobile / Name)
                </label>
                <div class="input-group input-group-lg frf-search-group">
                  <input id="frf-admission-search" type="search" class="form-control frf-search-input"
                    [(ngModel)]="searchAdmissionNo" name="searchAdmissionNo"
                    placeholder="Search by Adm No, Mobile No, Name" autocomplete="off"
                    (ngModelChange)="onSearchAdmissionNoChange($event)" (keydown.enter)="onSearchEnter($event)" />
                  <button type="button" class="btn frf-search-btn" aria-label="Search" (click)="onSearchClick()"
                    [disabled]="listLoading">
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="card shadow-sm border-0 frf-list-scroll">
              <div class="card-header bg-white d-flex align-items-center justify-content-between py-3">
                <span class="frf-section-title">
                  <i class="fa fa-graduation-cap me-2" aria-hidden="true"></i>
                  {{ searchResults !== null ? 'Search results' : 'Recent Students' }}
                </span>
                <span class="badge text-bg-light text-dark fs-6">{{ displayStudents.length }}</span>
              </div>

              <div class="card-body py-3" *ngIf="loading || listLoading">
                <div class="text-center text-secondary fw-semibold">Loading…</div>
              </div>

              <div class="list-group list-group-flush" *ngIf="!loading && !listLoading">
                <div class="list-group-item p-0 border-0" *ngFor="let s of displayStudents; trackBy: trackByAdmission">
                  <button type="button"
                    class="list-group-item list-group-item-action frf-student-list-btn d-flex align-items-center gap-3 py-3 border-0"
                    (click)="selectStudent(s)" [disabled]="listLoading">
                    <span
                      class="frf-avatar frf-avatar--initial rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0"
                      aria-hidden="true">{{ studentListInitial(s) }}</span>
                    <span class="text-start min-w-0 flex-grow-1">
                      <span class="d-block frf-student-name text-dark">{{ s.name }}</span>
                      <span class="d-block small text-secondary">{{ s.admissionNo }}</span>
                    </span>
                    <span *ngIf="orientationBadgeLabel(s) as orientationBadge"
                      class="frf-orientation-badge flex-shrink-0"
                      [class.frf-orientation-badge--day]="orientationBadge === 'Day'">{{ orientationBadge }}</span>
                    <span class="frf-list-chevron flex-shrink-0" aria-hidden="true">
                      <i class="fa fa-angle-right"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="card-body no_studentfound" *ngIf="!loading && !listLoading && displayStudents.length === 0">
                No students found.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <!-- —— Screen 2: Evaluation (new design) —— -->
  <ng-container *ngIf="selectedStudent && !submitted">
    <div class="wbr-eval">
      <div class="container wbr-eval__header">
        <div class="wbr-eval__header-left">
          <button type="button" class="wbr-eval__back-btn" (click)="back()" aria-label="Back">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
          </button>
          <h1 class="wbr-eval__title">Well Being Referral Form</h1>
        </div>
        <div class="wbr-eval__lang-select" [class.wbr-eval__lang-select--open]="langDropdownOpen">
          <button type="button" class="wbr-eval__lang-trigger" (click)="toggleLangDropdown($event)"
            aria-label="Select language" [attr.aria-expanded]="langDropdownOpen" aria-haspopup="listbox">
            <i class="fa-solid fa-globe wbr-eval__lang-globe" aria-hidden="true"></i>
            <span>{{ languageLabel }}</span>
            <i class="fa-solid fa-chevron-down wbr-eval__lang-chevron" aria-hidden="true"></i>
          </button>
          <ul *ngIf="langDropdownOpen" class="wbr-eval__lang-menu" role="listbox">
            <li *ngFor="let lang of languageOptions" role="option" class="wbr-eval__lang-item"
              [class.wbr-eval__lang-item--selected]="currentLang === lang.value" (click)="selectLanguage(lang.value)">
              {{ lang.label }}
            </li>
          </ul>
        </div>
      </div>

      <div class="container wbr-eval__severity" *ngIf="!showHistoryView && !questionsLoading && questions.length">
        <!-- <span class="wbr-eval__severity-label">Severity scale</span> -->
        <div class="wbr-eval__severity-cards">
          <div *ngFor="let item of scaleLegend" class="wbr-eval__severity-card"
            [ngClass]="'wbr-eval__severity-card--rank-' + item.value">
            <span class="wbr-eval__severity-card-num">{{ item.value }}</span>
            <span class="wbr-eval__severity-card-divider" aria-hidden="true"></span>
            <span class="wbr-eval__severity-card-body">
              <span class="wbr-eval__severity-card-title">{{ legendLabel(item) }}</span>
              <span class="wbr-eval__severity-card-sub">{{ legendSubtext(item.value) }}</span>
            </span>
          </div>
        </div>
        <!-- <div class="wbr-eval__severity-status">{{ concernsRatedLabel }}</div> -->
      </div>

      <div class="container wbr-eval__layout">
        <aside class="wbr-profile">
          <h2 class="wbr-profile__heading">Student profile</h2>

          <p class="wbr-profile__loading" *ngIf="profileLoading">Loading profile…</p>
          <p class="wbr-profile__error" *ngIf="!profileLoading && profileError">{{ profileError }}</p>

          <div class="wbr-profile__photo-wrap">
            <div class="wbr-profile__photo">
              <img *ngIf="studentPhotoUrl && !profilePhotoFailed" [src]="studentPhotoUrl"
                [alt]="selectedStudent.name + ' photo'" (error)="onProfilePhotoError()" />
              <i *ngIf="!studentPhotoUrl || profilePhotoFailed"
                class="fa-regular fa-user wbr-profile__photo-placeholder" aria-hidden="true"></i>
            </div>
            <span class="wbr-profile__badge">Active</span>
          </div>

          <h3 class="wbr-profile__name">{{ selectedStudent.name }}</h3>
          <p class="wbr-profile__subline">{{ studentSubline }}</p>

          <div class="wbr-profile__fields">
            <div class="wbr-profile__field">
              <span class="wbr-profile__field-label">Admission No</span>
              <span class="wbr-profile__field-value">{{ selectedStudent.admissionNo }}</span>
            </div>
            <div class="wbr-profile__field">
              <span class="wbr-profile__field-label">Parent Name</span>
              <span class="wbr-profile__field-value">{{ selectedStudent.parentName || '—' }}</span>
            </div>
            <div class="wbr-profile__field">
              <span class="wbr-profile__field-label">Campus</span>
              <span class="wbr-profile__field-value">{{ selectedStudent.campus }}</span>
            </div>
            <div class="wbr-profile__field">
              <span class="wbr-profile__field-label">Student Type</span>
              <span class="wbr-profile__field-value">{{ selectedStudent.boardingType }}</span>
            </div>
          </div>

        </aside>

        <main class="wbr-main">
          <p *ngIf="errorMessage" class="wbr-main__error">{{ errorMessage }}</p>

          <ng-container *ngIf="!showHistoryView">
            <div class="wbr-main__intro">
              <div class="wbr-main__intro-head">
                <h2 class="wbr-main__title">{{ evalHeadTitle }}</h2>
                <button type="button" class="wbr-profile__history-btn" (click)="onCheckHistory()"
                  [disabled]="historyLoading">
                  <i class="fa fa-history" aria-hidden="true"></i>
                  Check your History
                </button>
              </div>
              <p class="wbr-main__hint" *ngIf="!questionsLoading && questions.length">
                Select 1 · 2 · 3 for each concern below. Each question must be rated before submitting.
              </p>
              <p *ngIf="questionsLoading" class="wbr-main__loading">Loading questions…</p>
            </div>

            <div class="wbr-main__progress-wrap" *ngIf="!questionsLoading && questions.length">
              <div class="wbr-main__progress-track">
                <div class="wbr-main__progress-fill" [style.width.%]="progressPercent"></div>
              </div>
              <span class="wbr-main__progress-text">{{ completedLabel }}</span>
            </div>

            <form *ngIf="!questionsLoading && questions.length" class="wbr-main__form" (ngSubmit)="submit()">
              <div class="wbr-concerns-grid">
                <article *ngFor="let q of questions; trackBy: trackByQuestionId" class="wbr-concern-card"
                  [class.wbr-concern-card--full]="q.no === questions.length && questions.length % 2 === 1">
                  <div class="wbr-concern-card__head">
                    <span class="wbr-concern-card__num">{{ q.no }}</span>
                    <h3 class="wbr-concern-card__title">{{ questionLabel(q) }}</h3>
                  </div>
                  <ng-container *ngIf="options$(q.questionId) | async as opts">
                    <div class="wbr-concern-card__options" role="radiogroup" [attr.aria-label]="questionLabel(q)">
                      <button *ngFor="let o of opts; trackBy: trackByOptionId" type="button" class="wbr-severity-btn"
                        [ngClass]="[
                          scaleRankClass(o.optionRank),
                          isSelected(q.questionId, o.optionId) ? 'wbr-severity-btn--selected' : ''
                        ]" (click)="setAnswer(q.questionId, o)" [disabled]="submitting || questionsLoading"
                        [attr.aria-label]="scaleOptionButtonLabel(o)"
                        [attr.aria-pressed]="isSelected(q.questionId, o.optionId)">
                        <i *ngIf="isSelected(q.questionId, o.optionId)"
                          class="fa-solid fa-check wbr-severity-btn__check" aria-hidden="true"></i>
                        <span *ngIf="!isSelected(q.questionId, o.optionId)" class="wbr-severity-btn__dot"
                          aria-hidden="true"></span>
                        <span class="wbr-severity-btn__label">{{ scaleOptionButtonLabel(o) }}</span>
                      </button>
                    </div>
                  </ng-container>
                </article>
              </div>

              <div class="wbr-main__footer">
                <span class="wbr-main__points">{{ answeredCount }} / {{ totalQuestions }}</span>
                <div class="wbr-main__footer-actions">
                  <button type="button" class="wbr-main__clear-btn" (click)="clearAllAnswers()"
                    [disabled]="submitting || answeredCount === 0">
                    Clear All
                  </button>
                  <button type="submit" class="wbr-main__submit-btn" [disabled]="submitting || !canSubmitEvaluation">
                    {{ submitting ? 'Submitting…' : 'Submit Evaluation' }}
                    <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </form>
          </ng-container>

          <div class="feedback-history wbr-history" *ngIf="showHistoryView">
            <div class="wbr-history__top-actions">
              <button type="button" class="wbr-history__back-btn" (click)="onCheckHistory()"
                [disabled]="historyLoading">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                Back to Evaluation
              </button>
            </div>
            <p *ngIf="historyLoading" class="feedback-history__loading">Loading feedback history...</p>
            <ng-container *ngIf="!historyLoading">
              <div *ngIf="feedbackHistory.length" class="feedback-history__dates">
                <button *ngFor="let entry of feedbackHistory; let i = index" type="button"
                  class="feedback-history__date-tab"
                  [class.feedback-history__date-tab--active]="selectedHistoryDateIndex === i"
                  (click)="selectHistoryDate(i)">
                  {{ formatHistoryDate(entry) }}
                </button>
              </div>
              <div *ngIf="feedbackHistory.length" class="feedback-history__card">
                <div class="feedback-history__card-header">
                  <h2 class="feedback-history__card-title">{{ historyFeedbackCountLabel }}</h2>
                </div>
                <div class="feedback-history__card-body">
                  <div *ngFor="let q of getSelectedHistoryQuestions(); let i = index"
                    class="feedback-history__question">
                    <p class="feedback-history__question-text">Q{{ i + 1 }}. {{ q.question }}</p>
                    <div *ngFor="let opt of getSelectedHistoryOptions(q)" class="feedback-history__answer" [ngStyle]="{
                        'border-color': getHistoryRankStyles(getHistoryOptionRank(opt)).border,
                        'background-color': getHistoryRankStyles(getHistoryOptionRank(opt)).background
                      }">
                      <span class="feedback-history__rank"
                        [ngStyle]="{ 'background-color': getHistoryRankStyles(getHistoryOptionRank(opt)).circle }">
                        {{ getHistoryOptionRank(opt) }}
                      </span>
                      <span class="feedback-history__answer-text">{{ getHistoryOptionLabel(opt) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <p *ngIf="!feedbackHistory.length" class="feedback-history__empty">
                No feedback history found for this student.
              </p>
            </ng-container>
          </div>
        </main>
      </div>
    </div>
  </ng-container>

  <app-assessment-submit-confirm [open]="showSubmitConfirm" mode="confirm" theme="frf" confirmTitle="Submit evaluation?"
    confirmMessage="Are you sure you want to submit your evaluation." (confirmed)="confirmSubmit()"
    (cancelled)="cancelSubmitConfirm()"></app-assessment-submit-confirm>

  <app-assessment-submit-confirm [open]="showDialog" mode="success" theme="frf" [successTitle]="dialogTitle"
    [successMessage]="dialogMessage" (dismissed)="confirmationBack()"></app-assessment-submit-confirm>
</div>

<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>